export const resourceTypes = { business: 'Business', connection: 'Connection' };
